import { useCRUDList } from '@/shared/hooks/useCRUDList';
import { providerUserService } from '@/services/providerUser.service';
import type { ProviderUser } from '@/services/types/user.types';

const providerUserServiceAdapter = {
  getAll: () => providerUserService.getAllProviderUsers(),
  delete: (id: string) => providerUserService.deleteProviderUser(id),
};

export function useProviderUserList() {
  const {
    items: providerUsers,
    loading,
    handleNew,
    handleEdit,
    handleDelete,
  } = useCRUDList<ProviderUser>({
    service: providerUserServiceAdapter,
    entityName: 'usuário de prestadora',
    routes: {
      new: '/provider-register',
      edit: (id) => `/provider-edit/${id}`,
    },
    messages: {
      loadError: 'Erro ao carregar usuários de prestadoras',
      deleteSuccess: 'Usuário excluído com sucesso!',
      deleteError: 'Erro ao excluir usuário',
    },
  });

  const columns = [
    { key: 'name', title: 'Nome', dataIndex: 'name' },
    { key: 'email', title: 'Email', dataIndex: 'email' },
    { key: 'phoneNumber', title: 'Telefone', dataIndex: 'phoneNumber' },
  ];

  return {
    providerUsers,
    loading,
    columns,
    handleNew,
    handleEdit,
    handleDelete,
  };
}
